<template>
  <b-modal
    scrollable
    id="category-modal"
    ref="modal"
    :title="'Zarządzaj Kategoriami'"
    size="lg"
    :hide-footer="true"
  >
    <div class="input-group searching w-100 mr-0">
      <div class="searching-wrapper w-100">
        <input
          type="text"
          class="form-control"
          placeholder="Szukaj"
          aria-label="Szukaj"
          v-model="q"
        />
        <span class="searching-icon">
          <i class="fas fa-search"></i>
        </span>
        <span class="searching-clean" v-show="q" @click="q=''">
          <i class="fas fa-times"></i>
        </span>
      </div>
    </div>

    <b-table
      class="table table-list table-mobile"
      ref="bills_table"
      :filter="q"
      :filterIncludedFields="filterOn"
      :fields="fields"
      :busy.sync="isBusy"
      :items="categories"
      stacked="lg"
    >
      <template v-slot:top-row>
        <b-td>
          <b-form-input
            v-model="newCategory"
            placeholder="Wprowadź nazwe nowej kategorii wydatku"
            :state="newCategoryError"
          ></b-form-input>
        </b-td>
        <b-td class="text-right" style="width:120px">
          <button
            class="btn btn-outline-success btn-sm mr-3"
            @click="saveNew"
            :disabled="newCategory.length === 0"
          >Dodaj</button>
        </b-td>
      </template>

      <template v-slot:cell(name)="data">
        <div v-if="(selected && selected.id === data.item.id)">
          <b-form-input
            :value="selected.name"
            ref="categoryName"
            placeholder="Wprowadź nazwe kategori"
            autofocus
            @change="validInput"
            :state="noError"
          ></b-form-input>
        </div>
        <div v-else>{{data.item.name}}</div>
      </template>
      <template v-slot:cell(options)="data">
        <div v-if="(selected && selected.id === data.item.id)">
          <button
            class="btn btn-outline-success btn-sm mr-3"
            @click="saveEdited"
            :disabled="noError === false"
          >Zapisz</button>
          <button class="btn btn-outline-secondary btn-sm" @click="stopEdit">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div v-else>
          <button
            class="btn btn-outline-danger btn-sm mr-3"
            @click="remove(data.item)"
            v-if="data.item.id > 2"
          >
            <i class="far fa-trash-alt"></i>
          </button>
          <button
            class="btn btn-outline-primary btn-sm"
            @click="startEdit(data.item)"
            v-if="data.item.id > 2"
          >
            <i class="fas fa-pencil-alt"></i>
          </button>
        </div>
      </template>
    </b-table>
  </b-modal>
</template>


<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "BillsCategoryModalForm",
  data() {
    return {
      newCategory: "",
      newCategoryError: null,
      noError: null,
      q: "",
      filterOn: ["name"],
      isBusy: false,
      fields: [
        { key: "name", label: "Nazwa kategori" },
        { key: "options", label: "Opcje", class: "text-right" }
      ],
      selected: null
    };
  },
  computed: {
    ...mapGetters("bills", ["categories"])
  },
  methods: {
    ...mapActions("bills", ["deleteCategory", "updateCategory", "addCategory"]),
    validInput() {
      if (this.$refs.categoryName.localValue.length === 0) {
        this.noError = false;
      } else {
        this.noError = null;
      }
    },
    remove(item) {
      let h = this.$createElement;
      this.$bvModal
        .msgBoxConfirm(
          [
            h("p", [
              "Czy napewno chcesz usunąć kategorie: ",
              h("br"),
              h("br"),
              h("strong", item.name),
              " ?"
            ])
          ],
          {
            title: "Potwierdź usunięcie kategorii",
            okVariant: "danger",
            okTitle: "TAK",
            cancelTitle: "NIE"
          }
        )
        .then(result => {
          if (result !== true) {
            return;
          }
          this.$Progress.start();
          this.deleteCategory(item.id);
        });
    },
    startEdit(item) {
      this.noError = null;
      this.selected = item;
    },
    stopEdit() {
      this.noError = null;
      this.selected = null;
    },
    saveNew() {
      this.addCategory(this.newCategory)
        .then(() => {
          this.newCategory = "";
          this.newCategoryError = null;
        })
        .catch(() => {
          this.noError = false;
        });
    },
    saveEdited() {
      this.$Progress.start();
      let query = {
        categoryid: this.selected.id,
        name: this.$refs.categoryName.localValue
      };
      this.updateCategory(query)
        .then(this.stopEdit)
        .catch(() => {
          this.noError = false;
        });
    }
  }
};
</script>